import { render, staticRenderFns } from "./FilterCriteria.vue?vue&type=template&id=5224e7f0&scoped=true"
import script from "./FilterCriteria.vue?vue&type=script&lang=js"
export * from "./FilterCriteria.vue?vue&type=script&lang=js"
import style0 from "./FilterCriteria.vue?vue&type=style&index=0&id=5224e7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224e7f0",
  null
  
)

export default component.exports